import { retry } from "@reduxjs/toolkit/query";
import React, { useEffect, useState } from "react";
import InputAHSF from "../../../../Components/InputAHSF";
import { useDispatch, useSelector } from "react-redux";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../../Services/Encryption/EncryptionParams";
import $ from "jquery";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";
import { GetAllAcademicDegree } from "../../../../Redux/Reducers/Submitter/InformationAboutResearchers/AcademicDegreeDropdown";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import {
  GetAllSU_ST__MRI_TypeExperience,
  GetAllSU_ST_MRI_Nationality,
  GetSU_ST_MRI_Years,
} from "../../../../Redux/Reducers/Submitter/MainResearcherInformation/DropDown";
import {
  AddSU_NT_MRI_ResearchExperience,
  GetOneSU_NT_MRI_ResearchExperience,
  UpdateSU_NT_MRI_ResearchExperience,
} from "../../../../Redux/Reducers/Submitter/ResearchExperience";
import TextAreaAHSF from "../../../../Components/TextAreaAHSF";

const AddEditeResearchExperience = (props) => {
  const dispatch = useDispatch();
  const [editValue,setEditValue]=useState(null)
  const [editText,setEditText]=useState(null)

  const AppGuid = useParams();
  const [validatesummary, setvalidatesummary] = useState(false);
  const [validateparty, setvalidateparty] = useState(false);
  const [validateyearId, setvalidateyearId] = useState(false);
  const [validateaddress, setvalidateaddress] = useState(false);
  const [validatetypeExperienceId, setvalidatetypeExperienceId] =
    useState(false);
  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
      jsonData: state.FetchDataJson.JsonData,
      researchExperience: state.ResearchExperience.researchExperience,
      loadingresearchExperience:
        state.ResearchExperience.loadingresearchExperience,
      DropDownAcademicDegree:
        state.DropDownAcademicDegree.DropDownAcademicDegree,
      DropDownTypeExperience: state.DropDown.DropDownTypeExperience,
      DropDownSU_ST_MRI_Years: state.DropDown.DropDownSU_ST_MRI_Years,
    };
  });
  const [validateList, setvalidateList] = useState([]);
  const [list, setList] = useState({
    researchExperienceId: null,
    typeExperienceId: null,
    address: null,
    yearId: null,
    party: null,
    summary: null,
    applicationInformationId:
      localStorage.getItem("ApplicationInformationId") ||
      decryptToken(AppGuid.AppGuid),
  });
  const [show, setShow] = useState(false);
  const addExperience = async () => {
    if (
      list.address != "" &&
      list.address != null &&
      list.typeExperienceId != null &&
      list.yearId != "" &&
      list.yearId != null &&
      list.party != null &&
      list.party != "" &&
      list.summary != null &&
      list.summary != ""
    ) {
      const add = await dispatch(
        AddSU_NT_MRI_ResearchExperience({
          typeExperienceId: list.typeExperienceId,
          address: list.address,
          yearId: list.yearId,
          party: list.party,
          summary: list.summary,
          applicationInformationId:
            localStorage.getItem("ApplicationInformationId") ||
            decryptToken(AppGuid.AppGuid),
        })
      );

      if (add.payload) {
        $(".close-btn").trigger("click");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم اضافة المعلومات بنجاح", // "Information updated successfully"
          showConfirmButton: false,
          timer: 1500, // Display success message for 1.5 seconds.
        });

        // Refresh the table by dispatching the action to update the table data.
        dispatch(setRefreshTable());
      }
    } else {
      if (list.address == "" || list.address == null) {
        setvalidateaddress(true);
      }
      if (list.summary == "" || list.summary == null) {
        setvalidatesummary(true);
      }
      if (list.party == "" || list.party == null) {
        setvalidateparty(true);
      }
      if (list.yearId == "" || list.yearId == null) {
        setvalidateyearId(true);
      }
      if (list.typeExperienceId == "" || list.typeExperienceId == null) {
        setvalidatetypeExperienceId(true);
      }
    }
  };

  const updateExperience = async () => {
    if (
      list.address != "" &&
      list.address != null &&
      list.typeExperienceId != null &&
      list.yearId != "" &&
      list.yearId != null &&
      list.party != null &&
      list.party != "" &&
      list.summary != null &&
      list.summary != ""
    ) {
      const update = await dispatch(
        UpdateSU_NT_MRI_ResearchExperience({
          researchExperienceId: list.researchExperienceId,
          typeExperienceId: list.typeExperienceId,
          address: list.address,
          yearId: list.yearId,
          party: list.party,
          summary: list.summary,
          applicationInformationId: list.applicationInformationId,
        })
      );

      if (update.payload) {
        $(".close-btn").trigger("click");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم تعديل المعلومات بنجاح", // "Information updated successfully"
          showConfirmButton: false,
          timer: 1500, // Display success message for 1.5 seconds.
        });

        // Refresh the table by dispatching the action to update the table data.
        dispatch(setRefreshTable());
      }
    } else {
      if (list.address == "" || list.address == null) {
        setvalidateaddress(true);
      }
      if (list.summary == "" || list.summary == null) {
        setvalidatesummary(true);
      }
      if (list.party == "" || list.party == null) {
        setvalidateparty(true);
      }
      if (list.yearId == "" || list.yearId == null) {
        setvalidateyearId(true);
      }
      if (list.typeExperienceId == "" || list.typeExperienceId == null) {
        setvalidatetypeExperienceId(true);
      }
    }
  };

  const getData = async () => {
    if (props.canEdit) {
      const data = await dispatch(
        GetOneSU_NT_MRI_ResearchExperience(props.researchExperienceId)
      );

      if (data.payload) {
        setList({ ...data.payload });
        setShow(true);
      }
    } else {
      setShow(true);
    }
  };
  useEffect(() => {
    getData();
    dispatch(GetAllAcademicDegree());
    dispatch(GetAllSU_ST__MRI_TypeExperience());
    dispatch(GetSU_ST_MRI_Years());
  }, []);
  console.log(list, "djsdhdjdhsdj");

  return !state.loadingresearchExperience && show ? (
    <>
      <div className="AddEdite">
        <AllDropDownsAHSF
          fieldsName="type"
          show={true}
          disabled={props.shouldDisableFields}
          KeyText={"typeExperienceName"}
          KeyValue={"typeExperienceId"}
          arrayOoptionList={state.DropDownTypeExperience}
          dropdownType={"normal"}
          onChange={(e) => {
            setList({
              ...list,
              typeExperienceId: e.target.value,
            });
          }}
          defaultValue={list?.typeExperienceId}
          showValidationMessage={validatetypeExperienceId}
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <InputAHSF
          fieldsName="Address"
          show={true}
          disabled={props.shouldDisableFields}
          onChange={(e) => {
            setList({
              ...list,
              address: e.target.value,
            });
          }}
          defaultValue={list?.address}
          showValidationMessage={validateaddress}
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        {/* <InputAHSF
          fieldsName="Year"
          show={true}
          type={"number"}
          disabled={props.shouldDisableFields}
          onChange={(e) => {
            setList({
              ...list,
              yearId: e.target.value,
            });
          }}
          defaultValue={list?.yearId}
          showValidationMessage={validateyearId}
          validationMessage="يرجى تعبئة هذا الحقل"
        /> */}

        <AllDropDownsAHSF
           fieldsName="Year"
           hidelable={false}
           labelName={"السنة"}
           show={true}
           disabled={props.shouldDisableFields}
           valueEdite={list?.yearId}
           submissionStatus={props.canEdit?"edite":""}
           textEdite={props.canEdit?list?.yearName:editText}
          arrayOoptionList={state.DropDownSU_ST_MRI_Years}
          KeyText={"yearName"}
          id={"yearId"}
          dropdownType={"search"}
          defaultValue={list?.yearId}
          value={list?.yearId}
          OnClickLi={(e) => {
            console.log(e,"ddeeeeeedddddddddddddd");
            
            setEditValue( e.yearId)
            setEditText(e.yearName)
            setList({
              ...list,
              yearId: e.yearId,
            });
          }}
             showValidationMessage={validateyearId}
          validationMessage="يرجى تعبئة هذا الحقل"
          //   defaultValue={AdvertisingList.mP_MR_ItemId}
        />


        {/* <AllDropDownsAHSF
          fieldsName="Year"
          hidelable={false}
          labelName={"السنة"}
          show={true}
          disabled={props.shouldDisableFields}
          KeyText={"yearName"}
          KeyValue={"yearId"}
          submissionStatus={"edite"}
          arrayOoptionList={state.DropDownSU_ST_MRI_Years}
          dropdownType={"search"}
          id={"yearId"}
          OnClickLi={(e) => {
            console.log(e, "FDFFDDFFD");

            setList({
              ...list,
              yearId: e.yearId,
            });
          }}
          defaultValue={list?.yearId}
          value={list?.yearId}
          showValidationMessage={validateyearId}
          validationMessage="يرجى تعبئة هذا الحقل"
        /> */}
        {/* <AllDropDownsAHSF
          fieldsName="Year"
          show={true}
          disabled={props.shouldDisableFields}
          KeyText={"yearName"}
          KeyValue={"yearId"}
          arrayOoptionList={state.DropDownSU_ST_MRI_Years}
          dropdownType={"normal"}
          onChange={(e) => {
            setList({
              ...list,
              yearId: e.target.value,
            });
          }}
          defaultValue={list?.yearId}
          showValidationMessage={validateyearId}
          validationMessage="يرجى تعبئة هذا الحقل"
        /> */}
        <InputAHSF
          fieldsName="party"
          show={true}
          disabled={props.shouldDisableFields}
          onChange={(e) => {
            setList({
              ...list,
              party: e.target.value,
            });
          }}
          defaultValue={list?.party}
          showValidationMessage={validateparty}
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <TextAreaAHSF
          fieldsName="Summary"
          show={true}
          disabled={props.shouldDisableFields}
          defaultValue={list?.summary}
          onChange={(e) => {
            setList({
              ...list,
              summary: e.target.value,
            });
          }}
          showValidationMessage={validatesummary}
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        {!props.shouldDisableFields ? (
          <div className="containersButton">
            <div>
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  props.canEdit == "edit"
                    ? updateExperience()
                    : addExperience();
                }}
                disabled={false}
                title={props.canEdit == "edit" ? "تعديل" : "اضافة"}
                text={props.canEdit == "edit" ? "تعديل" : "اضافة"}
                show={true}
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  ) : (
    ""
  );
};

export default AddEditeResearchExperience;
